import * as ng from 'angular';

export const Uppercase = () => (<angular.IDirective>{

    require: 'ngModel',

    link: (scope: ng.IScope, element: any, attrs: any, modelCtrl: ng.INgModelController) => {
        let uppercase = (inputValue) => {
            if (inputValue === undefined) {
                inputValue = '';
            }
            let uppercased = inputValue.toUpperCase();
            if (uppercased !== inputValue) {
                let selection = element[0].selectionStart;
                modelCtrl.$setViewValue(uppercased);
                modelCtrl.$render();
                element[0].selectionStart = selection;
                element[0].selectionEnd = selection;
            }
            return uppercased;
        };
        modelCtrl.$parsers.push(uppercase);
        uppercase(scope[attrs.ngModel]); // capitalize initial value
    }
});




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/directives/uppercase/uppercase.directive.ts